'use strict';

/**
 * @ngdoc filter
 * @name gfcmsApp.filter:address
 * @function
 * @description
 * # address
 * Filter in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .filter('address', function () {
    return function (address) {
      if(angular.isUndefined(address) || address === null || !address.address)
      {
        return '  ';
      }
      return address.address + ', ' + address.town + ' ' + address.postcode;
    };
  });
